export const BLACKLISTED_SENTRY_ERRORS = [
  'Can not register with opener: no bridge found in opener',
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
  'cancelled',
  'cancelado',
  '已取消',
  'отменено',
  'annulé',
  'キャンセルしました',
  'annullato',
  'Abgebrochen',
  'geannuleerd',
  'dibatalkan',
  'đã hủy',
  'anulat',
  '취소됨',
  '网络连接已中断。',
  'Đã mất kết nối mạng.',
  'Сетевое соединение потеряно.',
  'privateSpecialRepair is not defined',
  'window.bannerNight is not a function',
  "Can't find variable: WeixinJSBridge",
];
